<template>
	<footer id="Footer">
		<div class="container">
			<span class="border"></span>
			<section class="col-address">
				<h1 class="logo-stormgroup rpl"><router-link :to="{ name: 'home'}">StormGroup</router-link></h1>
				<address>
					<strong>Rio de Janeiro</strong> | Av. João Cabral de Mello Neto, 850 Bloco 2 Sala 304 <br> Ed. CEO Corporate<br>
					Barra da Tijuca, Rio de Janeiro/RJ - CEP: 22775-057 <br>
					Office: +55 (21) 3734-0695
					<br><br>
					New York | 136 Madison Avenue, 5th Floor <br>
					New York, NY 10016 <br>
					Office: +1 (646) 722 3838
				</address>
				<p>© 2018 STORMGROUP. TODOS OS DIREITOS RESERVADOS.</p>
			</section>
			<nav class="foot-menu">
				<div class="links">
					<router-link v-for="rota in rotas" :to="rota.path ? rota.path : '/'" exact>
						{{ rota.titulo }}
					</router-link>
				</div>
				<div class="social-share">
					<SocialShare />
				</div>
			</nav>
		</div>
	</footer>
</template>

<script>

    import SocialShare from './SocialShare.vue';
    export default {

        components: {
            SocialShare
        },

        props: {
            rotas: {
                type: Array,
                required: true
            }
        }
    };
</script>

<style lang="scss">
	#Footer {
		background-color: #222831;
		position: relative;
		padding: 50px 0;
		overflow: hidden;

		.container {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;

			.logo-stormgroup {
				width: 202px;
				height: 24px;
				margin-bottom: 25px;
			}

			.col-address {
				color: #fff;
				font-size: 1.1em;
				line-height: 18px;
				flex-basis: auto;

				address {
					font-style: normal;
					margin-bottom: 15px;
				}
			}

			.foot-menu {
				flex-basis: 70%;
				text-align: right;

				.social-share {
					.socialShare {
						text-align: right;
						margin-top: 10px;
					}
					a {
						font-size: 30px;
					}
				}

				.links {
					a {
						color: #eee;
						display: inline-block;
						font-size: 1.4em;
						text-transform: uppercase;
						line-height: 28px;
						margin-left: 20px;
						transition: all linear .2s;

						&:hover {
							color: #3ab8e8;
						}
					}
				}
			}

			.border {
				display: block;
				position: absolute;
				top: 0px;
				right: 0px;
				width: 0px;
				height: 0px;
				border-style: solid;
				border-color: #3ab8e8;
				border-width: 0px 200em 20px 0px;
				border-bottom-color: transparent;
			}
		}
	}

	@media (max-width: 1024px) {

		#Footer {
			text-align: center;

			.border {
				border-width: 0 77em 20px 0;
			}

			.container {
				flex-wrap: wrap;

				.col-address {
					margin: 0 auto 20px auto;
					flex-basis: 100%;
				}

				.foot-menu {
					flex-basis: 100%;
				}
			}

			.logo-stormgroup {
				margin: 0 auto 25px auto;
			}

			.socialShare {
				margin-top: 10px;
			}
		}
	}

	@media (max-width: 768px) {

		#Footer {
			text-align: center;

			.border {
				border-width: 0 77em 20px 0;
			}

			.container {
				flex-wrap: wrap;

				.col-address {
					margin: 0 auto 20px auto;
					flex-basis: 100%;
				}

				.foot-menu {
					flex-basis: 100%;
					text-align: center;

					.links {
						a {
							&:first-child {
								margin-left: 0;
							}
						}
					}

					.social-share {
						.socialShare {
							text-align: center;
						}
					}
				}
			}

			.logo-stormgroup {
				margin: 0 auto 25px auto;
			}

			.socialShare {
				margin-top: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue